module.exports = __webpack_public_path__ + "static/media/Automobiles.da10380a.jpg";